import React from "react";

const PerformanceRing = ({
  percent = 0,
  color = "#22c55e",
  trackColor = "#e5e7eb",
}) => {
  const value = Math.max(0, Math.min(100, Number(percent) || 0));
  const bg = `conic-gradient(${color} ${value * 3.6}deg, ${trackColor} 0deg)`;

  return (
    <div className="pd-ring-wrap">
      <div className="pd-ring">
        {/* Track is masked into a thin donut so the panel shows through */}
        <span className="pd-ring-track" style={{ background: bg }} />
        <span className="pd-ring-inner" style={{ color }}>
          {value.toFixed(2)}%
        </span>
      </div>
      <div className="pd-ring-label">Performance</div>
    </div>
  );
};

export default PerformanceRing;
